module.exports = __webpack_public_path__ + "static/media/v261-minty-financedoodle-35.a88f06c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/v261-minty-financedoodle-35.png
// module id = 31
// module chunks = 0